import { UsersGridView } from '~/components/system/users';
import { PageContainer } from '~/components/page-container';

export function Users() {
	return (
		<PageContainer>
			<UsersGridView />
		</PageContainer>
	);
}
